import { EmailTemplatesGridView } from '~/components/system/email-templates';
import { PageContainer } from '~/components/page-container';

export function EmailTemplates() {
	return (
		<PageContainer>
			<EmailTemplatesGridView />
		</PageContainer>
	);
}
